import config from 'config'
import { SalesRepsMetricCategories } from 'types/salesRepSetup'

export const KPICardConstants = [
  {
    id: 1,
    title: 'Team assigned',
    description: 'What percentage of sales reps are assigned to a team?',
    modalSubtitle: 'Sales reps who have not been assigned to a team',
    metricIdentifier: SalesRepsMetricCategories.TEAM_ASSIGNED,
  },
  {
    id: 2,
    title: 'Name added',
    description: 'What percentage of sales reps have a name?',
    modalSubtitle: 'Sales reps who are missing a name',
    metricIdentifier: SalesRepsMetricCategories.NAME_ADDED,
  },
  {
    id: 3,
    title: 'Profile photo uploaded',
    description: 'What percentage of sales reps have a profile photo?',
    modalSubtitle: 'Sales reps who have not uploaded a profile photo',
    metricIdentifier: SalesRepsMetricCategories.PHOTO_UPLOADED,
  },
  {
    id: 4,
    title: 'Notifications enabled',
    description:
      'What percentage of sales reps have desktop notifications turned on?',
    modalSubtitle:
      'Sales reps that do not have desktop notifications turned on',
    metricIdentifier: SalesRepsMetricCategories.NOTIFICATIONS_ENABLED,
  },
  {
    id: 5,
    title: 'Calendar connected',
    description: 'What percentage of sales reps connect their calendar?',
    modalSubtitle: 'Sales reps who have not connected their calendar',
    metricIdentifier: SalesRepsMetricCategories.CALENDAR_CONNECTED,
  },
  {
    id: 6,
    title: 'Conference link added',
    description: 'What percentage of sales reps have a conference link?',
    modalSubtitle:
      'Sales reps who do not have a conference link in their default meeting',
    metricIdentifier: SalesRepsMetricCategories.CONFERENCE_LINK_ADDED,
  },
]

export const MAX_USER_LAST_ACTIVE_TIME = '1+ year ago'

export const MANAGE_TEAMMATES_LINK = `${config.APP_URL}/settings2/team/teammates`
export const EDIT_USER_LINK = `${config.APP_URL}/settings2/team/edit`
export const GET_HELP_LINK =
  'https://help.salesloft.com/s/article/How-to-Add-Users-to-your-Team'
export const ENABLE_NOTIFICATIONS_HELP_LINK =
  'https://gethelp.drift.com/s/article/How-Do-Notifications-Work'
export const ADD_CONFRENCE_HELP_LINK =
  'https://help.salesloft.com/s/article/Setting-Up-Meetings-with-Drift'
export const USER_HELP_LINK =
  'https://help.salesloft.com/s/article/Quick-Start-Guide-for-New-Sales-Users'
